import { toDate as e } from "./toDate.js";
function a(t) {
  return e(t).getFullYear();
}
export {
  a as default,
  a as getYear
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getYear.js
// module id = 429
// module chunks = 41